module.exports = __webpack_public_path__ + "static/img/banner-csr-13.0d1730d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-13.jpg
// module id = DE0E
// module chunks = 98